export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      '&:before': {
        backgroundColor: colors.secondary
      },
      '&.completed:after': {
        backgroundColor: colors.secondary
      }
    }
  };
});